import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
        style: {
          // Default styles
        },
      }}
      style={{
        '--success-bg': '#ecfdf5',
        '--success-border': '#a7f3d0',
        '--success-text': '#065f46',
        '--error-bg': '#fef2f2',
        '--error-border': '#fecaca',
        '--error-text': '#991b1b',
      }}
      {...props} />
  );
}

// Custom styled toast functions
const styledToast = {
  success: (message, options = {}) => {
    return toast.success(message, {
      duration: 4000,
      ...options,
      style: {
        backgroundColor: '#ecfdf5',
        border: '1px solid #a7f3d0',
        color: '#065f46',
      },
    });
  },
  error: (message, options = {}) => {
    return toast.error(message, {
      duration: 6000, // Longer duration for errors
      ...options,
      style: {
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        color: '#991b1b',
        fontWeight: '500',
      },
    });
  },
  warning: (message, options = {}) => {
    return toast.warning(message, {
      duration: 5000,
      ...options,
      style: {
        backgroundColor: '#fffbeb',
        border: '1px solid #fde68a',
        color: '#92400e',
      },
    });
  },
  info: (message, options = {}) => {
    return toast.info(message, {
      duration: 5000,
      ...options,
      style: {
        backgroundColor: '#eff6ff',
        border: '1px solid #bfdbfe',
        color: '#1e40af',
      },
    });
  },
};

export { Toaster, toast, styledToast }
